/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
==========================================================================================*/

import _ from 'lodash'
let monthNames = ["JANV", "FÉVR", "MARS", "AVRI", "MAI ", "JUIN", "JUIL", "AOÛT", "SEPT", "OCTO", "NOVE", "DÉCE"]
let currentParamMonth = []
function getcurrentParam() {
  currentParamMonth = []
  let currentMonth = new Date().getMonth();
  let i = 0;
  for (i = currentMonth; i < monthNames.length; i++) {
    currentParamMonth.push(monthNames[i])
  }
  for (i = 0; i < currentMonth; i++) {
    currentParamMonth.push(monthNames[i])
  }
  return currentParamMonth;
}
function compare(a, b) {
  let months = getcurrentParam()
  if (a.Year == b.Year) {
    if (months.indexOf(a.Month.substring(0, 4)) < months.indexOf(b.Month.substring(0, 4)))
      return -1
    else return 1
  }

  else if (a.Year < b.Year)
    return -1
  else return 1
}
function compareMonth(a, b) {
  let months = monthNames
  if (a.substring(5, 9) == b.substring(5, 9)) {
    if (months.indexOf(a.substring(0, 4)) < months.indexOf(b.substring(0, 4)))
      return -1
    else if (months.indexOf(a.substring(0, 4)) > months.indexOf(b.substring(0, 4)))
      return 1
    else return 0;
  }

  else if (a.substring(5, 9) < b.substring(5, 9))
    return -1
  else return 1
}

export default {

  getTopFiveSalse: state => state.articles.filter(f => f.Entry_Type == 'Sale').sort(function (a, b) {
    return a.Sum_Quantity - b.Sum_Quantity;
  }).slice(1, 5)

  ,
  getTopFivePurchase: state => _.groupBy(state.articles.filter(f => f.Entry_Type == 'Purchase'), 'Item_No'),

  getMesArticles: state => _.uniqBy(state.articles, 'Item_No'),

  LineChartItemSalePurchase: state => (item, type) => { // vente d'article par mois d vs d-1   // page mes article 1 er courbe
    let firstYear=new Date().getFullYear()
    let pastYear=firstYear-1 ;

    let categories = [];
    let series = [{
      data: [],
      name: 'Vente '+ item  + "  en " + pastYear
    }, {
      data: [],
      name:'Vente '+ item + "  en " + firstYear
    }];
     let x=0 ;
     for (x=0;x<12 ;x++) // an est pas supprimer :pp 
     {
       series[0].data[x]=0
       series[1].data[x]=0
     }
    var newArray = state.articles.filter(function (
      el
    ) {
      return el.Item_No == item && el.Entry_Type == type;
    });
    if(item=='1041')
    console.log(newArray)
    let e = 0;
    newArray.sort((a, b) => compare(a, b))
       categories=monthNames ;
    for (e = 0; e < newArray.length; e++) {
    
      if (newArray[e].Year == firstYear) {
        series[1].data[
          monthNames.indexOf(newArray[e].Month.substring(0, 4))
        ] = newArray[e].Quantity;

         
      } else {

        series[0].data[monthNames.indexOf(newArray[e].Month.substring(0, 4))] = newArray[e].Quantity;
        
      }


    }
    console.log(newArray)
    return {
      'series': series,
      'categories': categories
    }
  }


  , ColumnChartItemSalePurchase: state => (item,year) => {
    console.log("call getters column chart " + item)

    let series = [{ data: [], name: 'Vente ' }, { data: [], name: 'Achat ' }]
    let categories = []
    var SaleArray = state.articles.filter(function (
      el
    ) {
      return el.Item_No == item && el.Entry_Type == 'Sale' && el.Year==year;
    });
    var PurchaseArray = state.articles.filter(function (
      el
    ) {
      return el.Item_No == item && el.Entry_Type == "Purchase" && el.Year==year;
    });
if(SaleArray.length==0 && PurchaseArray.length==0 )
return    {
  'series': series,
  'categories': categories
}
console.log(SaleArray)
    let i = 0;

    let length = SaleArray.length
    if (SaleArray.length < PurchaseArray.length)
      length = PurchaseArray.length
    let unionMonth = _.uniq(_.map(_.union(SaleArray, PurchaseArray), a => a.Month));
    unionMonth.sort(compareMonth)
    for (i = 0; i < length; i++) {
      //let month = SaleArray[i].Month.substring(0, 5)
      series[0].data[unionMonth.indexOf(SaleArray[i].Month)] = SaleArray[i].Sum_Quantity;
      categories[unionMonth.indexOf(SaleArray[i].Month)] = SaleArray[i].Month
      if (PurchaseArray[i] != null) {
        series[1].data[unionMonth.indexOf(PurchaseArray[i].Month)] = PurchaseArray[i].Sum_Quantity;
        categories[unionMonth.indexOf(PurchaseArray[i].Month)] = PurchaseArray[i].Month

      }
      categories = unionMonth

    }
    series[0].name = "Vente de l'article " + item + "   ";
    series[1].name = "Achat de l'article " + item + "  ";
    console.log(categories)
    return {
      'series': series,
      'categories': categories
    }
  },
  SumAmountPerMonth: state => {
    var  SumAmount =[]
    let unionMonth = _.uniq(_.map(state.articles, a => a.Month));
    unionMonth.sort(compareMonth)


   SumAmount= _.reduce(state.articles,function(seed, value) {
     let res ; 
 
    if (!seed[value.Month.replace(/\s/g, '')]) {
      res = { Month: value.Month.replace(/\s/g, ''), sumSale: 0, sumPurchase: 0 }
      seed[value.Month.replace(/\s/g, '')] =res
    }
    seed[value.Month.replace(/\s/g, '')].sumSale += value.Sum_Sales_Amount_Actual
    seed[value.Month.replace(/\s/g, '')].sumPurchase += value.Sum_Purchase_Amount_Actual

    return seed ;
  })
  let series= [{data : [], name :''},{data : [], name :''}]

  let i=0 ;
  for(i=0;i<SumAmount.length;i++)
  {
  series[0].data[unionMonth.indexOf(SumAmount[i].Month)]=SumAmount[i].sumSale
  series[0].data[unionMonth.indexOf(SumAmount[i].Month)]=SumAmount[i].sumPurchase
  }
  series[0].name='Sales sum'
  series[1].name='Purchases sum'
 console.log(SumAmount)
 let categories= unionMonth
 return {
   'categories': categories ,
   'series' :  series
 }; 
}
    
 
}
